import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditSuggerimentoComponent } from './dialogs/edit/edit.component';
import { SuggerimentiComponent } from './suggerimenti.component';



@NgModule({
  declarations: [SuggerimentiComponent,
    EditSuggerimentoComponent,],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
  ],
  exports: [SuggerimentiComponent,
    EditSuggerimentoComponent,]
})
export class SuggerimentiModule { }
